import { useQueryStates, parseAsArrayOf, parseAsString } from 'nuqs'

export const useDayforceJobsIssuesFiltersQueryState = () => {
  return useQueryStates(
    {
      agencyId: parseAsArrayOf(parseAsString).withDefault([
        '5b488f4f-391f-405a-87ca-1811a0f63ac8', // WorkWhile prod agency
      ]),
    },
    {
      urlKeys: {
        agencyId: 'agency-id',
      },
    }
  )
}
